/* global grecaptcha */

import { waitForGlobal } from '../utils/scriptLoader'
import BaseDriver from './BaseDriver'

/**
 * RecaptchaV3Driver - Handles reCAPTCHA v3 (invisible, score-based)
 */
class RecaptchaV3Driver extends BaseDriver {
  async waitForLibrary() {
    await waitForGlobal('grecaptcha', 'execute', 30000)
  }

  async getToken(action = 'submit') {
    return new Promise((resolve, reject) => {
      grecaptcha.ready(() => {
        grecaptcha.execute(this.publicKey, { action }).then(resolve).catch(reject)
      })
    })
  }

  // noinspection JSCheckFunctionSignatures
  watchForElements() {
    // V3 doesn't render elements, no-op
  }
}

export default RecaptchaV3Driver
